import JSEncrypt from 'jsencrypt';
import CryptoJS from 'crypto-js';


// Encrypt Data Transmission with Private & Public Key
export const Encrypt = (values) => {
  const jsonValues = JSON.stringify(values);

  // Step 1: Generate AES key (256 bits)
  const aesKey = CryptoJS.lib.WordArray.random(32); // AES key (256-bit)
  const aesIv = CryptoJS.lib.WordArray.random(16); // AES IV (128-bit)

  // Step 2: Encrypt the data with AES
  const data = CryptoJS.AES.encrypt(jsonValues, aesKey, { iv: aesIv }).toString();

  // Step 3: Encrypt the AES key using RSA (public key)
  const encryptor = new JSEncrypt();
  encryptor.setPublicKey(process.env.REACT_APP_MYHUB_PUBLIC_KEY);
  const aes_key = encryptor.encrypt(aesKey.toString(CryptoJS.enc.Base64));

  // Step 4: Return encrypted data and RSA-encrypted AES key
  return {
    data,
    aes_key,
    iv: aesIv.toString(CryptoJS.enc.Base64) // Return IV used for AES encryption
  };
};

/**
 * Use for every `axios.post(dbUserAndHub, …)` body. Same encryption as {@link Encrypt}.
 */
export const encryptUserAndHubPayload = (payload) => {
  return Encrypt(payload);
};